export type IconsId =
  | 'active-orders_new'
  | 'active-orders'
  | 'arrow-half'
  | 'arrow-top'
  | 'back'
  | 'bell-1'
  | 'bell'
  | 'box'
  | 'branches-tree'
  | 'button'
  | 'calendar'
  | 'call'
  | 'car'
  | 'card'
  | 'cash'
  | 'categories'
  | 'check'
  | 'chevron'
  | 'clock'
  | 'close-small'
  | 'close'
  | 'cluster'
  | 'copy_new'
  | 'copy'
  | 'cube'
  | 'curbside'
  | 'date-time'
  | 'delivery_declined'
  | 'delivery'
  | 'dine-in'
  | 'drag-hand-horizontal'
  | 'drag-hand'
  | 'dry-clean'
  | 'edit'
  | 'email'
  | 'exclusions'
  | 'geo'
  | 'gift'
  | 'hand'
  | 'heart-empty'
  | 'hint-arrow'
  | 'history_orders'
  | 'ic_card'
  | 'ic_cash'
  | 'ic_delivery_request'
  | 'ic_delivery-tracking'
  | 'ic_dsp-management'
  | 'ic_eye_crossed_out'
  | 'ic_eye'
  | 'ic_link_away'
  | 'ic_loader'
  | 'ic_search'
  | 'ic_target'
  | 'info'
  | 'information'
  | 'items'
  | 'logout'
  | 'management_car'
  | 'map-location'
  | 'map'
  | 'megafon'
  | 'menu_groups'
  | 'menu-1'
  | 'menu-dots'
  | 'menu'
  | 'minus'
  | 'modifiers'
  | 'no-results'
  | 'ok'
  | 'pencil'
  | 'pin-filled'
  | 'pin'
  | 'plus'
  | 'points'
  | 'products'
  | 'question'
  | 'reports'
  | 'reset'
  | 'reverse-arrows'
  | 'search'
  | 'selected-map-location'
  | 'selected-pin'
  | 'serving_dish'
  | 'settings'
  | 'shopping-bag'
  | 'shopping-cart'
  | 'slider-left'
  | 'slider-right'
  | 'smile'
  | 'spinner'
  | 'star'
  | 'swap'
  | 'terminal'
  | 'text'
  | 'trash'
  | 'wallet-1'
  | 'wallet'
  | 'warning';

export type IconsKey =
  | 'ActiveOrdersNew'
  | 'ActiveOrders'
  | 'ArrowHalf'
  | 'ArrowTop'
  | 'Back'
  | 'Bell_1'
  | 'Bell'
  | 'Box'
  | 'BranchesTree'
  | 'Button'
  | 'Calendar'
  | 'Call'
  | 'Car'
  | 'Card'
  | 'Cash'
  | 'Categories'
  | 'Check'
  | 'Chevron'
  | 'Clock'
  | 'CloseSmall'
  | 'Close'
  | 'Cluster'
  | 'CopyNew'
  | 'Copy'
  | 'Cube'
  | 'Curbside'
  | 'DateTime'
  | 'DeliveryDeclined'
  | 'Delivery'
  | 'DineIn'
  | 'DragHandHorizontal'
  | 'DragHand'
  | 'DryClean'
  | 'Edit'
  | 'Email'
  | 'Exclusions'
  | 'Geo'
  | 'Gift'
  | 'Hand'
  | 'HeartEmpty'
  | 'HintArrow'
  | 'HistoryOrders'
  | 'IcCard'
  | 'IcCash'
  | 'IcDeliveryRequest'
  | 'IcDeliveryTracking'
  | 'IcDspManagement'
  | 'IcEyeCrossedOut'
  | 'IcEye'
  | 'IcLinkAway'
  | 'IcLoader'
  | 'IcSearch'
  | 'IcTarget'
  | 'Info'
  | 'Information'
  | 'Items'
  | 'Logout'
  | 'ManagementCar'
  | 'MapLocation'
  | 'Map'
  | 'Megafon'
  | 'MenuGroups'
  | 'Menu_1'
  | 'MenuDots'
  | 'Menu'
  | 'Minus'
  | 'Modifiers'
  | 'NoResults'
  | 'Ok'
  | 'Pencil'
  | 'PinFilled'
  | 'Pin'
  | 'Plus'
  | 'Points'
  | 'Products'
  | 'Question'
  | 'Reports'
  | 'Reset'
  | 'ReverseArrows'
  | 'Search'
  | 'SelectedMapLocation'
  | 'SelectedPin'
  | 'ServingDish'
  | 'Settings'
  | 'ShoppingBag'
  | 'ShoppingCart'
  | 'SliderLeft'
  | 'SliderRight'
  | 'Smile'
  | 'Spinner'
  | 'Star'
  | 'Swap'
  | 'Terminal'
  | 'Text'
  | 'Trash'
  | 'Wallet_1'
  | 'Wallet'
  | 'Warning';

export enum Icons {
  ActiveOrdersNew = 'active-orders_new',
  ActiveOrders = 'active-orders',
  ArrowHalf = 'arrow-half',
  ArrowTop = 'arrow-top',
  Back = 'back',
  Bell_1 = 'bell-1',
  Bell = 'bell',
  Box = 'box',
  BranchesTree = 'branches-tree',
  Button = 'button',
  Calendar = 'calendar',
  Call = 'call',
  Car = 'car',
  Card = 'card',
  Cash = 'cash',
  Categories = 'categories',
  Check = 'check',
  Chevron = 'chevron',
  Clock = 'clock',
  CloseSmall = 'close-small',
  Close = 'close',
  Cluster = 'cluster',
  CopyNew = 'copy_new',
  Copy = 'copy',
  Cube = 'cube',
  Curbside = 'curbside',
  DateTime = 'date-time',
  DeliveryDeclined = 'delivery_declined',
  Delivery = 'delivery',
  DineIn = 'dine-in',
  DragHandHorizontal = 'drag-hand-horizontal',
  DragHand = 'drag-hand',
  DryClean = 'dry-clean',
  Edit = 'edit',
  Email = 'email',
  Exclusions = 'exclusions',
  Geo = 'geo',
  Gift = 'gift',
  Hand = 'hand',
  HeartEmpty = 'heart-empty',
  HintArrow = 'hint-arrow',
  HistoryOrders = 'history_orders',
  IcCard = 'ic_card',
  IcCash = 'ic_cash',
  IcDeliveryRequest = 'ic_delivery_request',
  IcDeliveryTracking = 'ic_delivery-tracking',
  IcDspManagement = 'ic_dsp-management',
  IcEyeCrossedOut = 'ic_eye_crossed_out',
  IcEye = 'ic_eye',
  IcLinkAway = 'ic_link_away',
  IcLoader = 'ic_loader',
  IcSearch = 'ic_search',
  IcTarget = 'ic_target',
  Info = 'info',
  Information = 'information',
  Items = 'items',
  Logout = 'logout',
  ManagementCar = 'management_car',
  MapLocation = 'map-location',
  Map = 'map',
  Megafon = 'megafon',
  MenuGroups = 'menu_groups',
  Menu_1 = 'menu-1',
  MenuDots = 'menu-dots',
  Menu = 'menu',
  Minus = 'minus',
  Modifiers = 'modifiers',
  NoResults = 'no-results',
  Ok = 'ok',
  Pencil = 'pencil',
  PinFilled = 'pin-filled',
  Pin = 'pin',
  Plus = 'plus',
  Points = 'points',
  Products = 'products',
  Question = 'question',
  Reports = 'reports',
  Reset = 'reset',
  ReverseArrows = 'reverse-arrows',
  Search = 'search',
  SelectedMapLocation = 'selected-map-location',
  SelectedPin = 'selected-pin',
  ServingDish = 'serving_dish',
  Settings = 'settings',
  ShoppingBag = 'shopping-bag',
  ShoppingCart = 'shopping-cart',
  SliderLeft = 'slider-left',
  SliderRight = 'slider-right',
  Smile = 'smile',
  Spinner = 'spinner',
  Star = 'star',
  Swap = 'swap',
  Terminal = 'terminal',
  Text = 'text',
  Trash = 'trash',
  Wallet_1 = 'wallet-1',
  Wallet = 'wallet',
  Warning = 'warning',
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.ActiveOrdersNew]: '61697',
  [Icons.ActiveOrders]: '61698',
  [Icons.ArrowHalf]: '61699',
  [Icons.ArrowTop]: '61700',
  [Icons.Back]: '61701',
  [Icons.Bell_1]: '61702',
  [Icons.Bell]: '61703',
  [Icons.Box]: '61704',
  [Icons.BranchesTree]: '61705',
  [Icons.Button]: '61706',
  [Icons.Calendar]: '61707',
  [Icons.Call]: '61708',
  [Icons.Car]: '61709',
  [Icons.Card]: '61710',
  [Icons.Cash]: '61711',
  [Icons.Categories]: '61712',
  [Icons.Check]: '61713',
  [Icons.Chevron]: '61714',
  [Icons.Clock]: '61715',
  [Icons.CloseSmall]: '61716',
  [Icons.Close]: '61717',
  [Icons.Cluster]: '61718',
  [Icons.CopyNew]: '61719',
  [Icons.Copy]: '61720',
  [Icons.Cube]: '61721',
  [Icons.Curbside]: '61722',
  [Icons.DateTime]: '61723',
  [Icons.DeliveryDeclined]: '61724',
  [Icons.Delivery]: '61725',
  [Icons.DineIn]: '61726',
  [Icons.DragHandHorizontal]: '61727',
  [Icons.DragHand]: '61728',
  [Icons.DryClean]: '61729',
  [Icons.Edit]: '61730',
  [Icons.Email]: '61731',
  [Icons.Exclusions]: '61732',
  [Icons.Geo]: '61733',
  [Icons.Gift]: '61734',
  [Icons.Hand]: '61735',
  [Icons.HeartEmpty]: '61736',
  [Icons.HintArrow]: '61737',
  [Icons.HistoryOrders]: '61738',
  [Icons.IcCard]: '61739',
  [Icons.IcCash]: '61740',
  [Icons.IcDeliveryRequest]: '61741',
  [Icons.IcDeliveryTracking]: '61742',
  [Icons.IcDspManagement]: '61743',
  [Icons.IcEyeCrossedOut]: '61744',
  [Icons.IcEye]: '61745',
  [Icons.IcLinkAway]: '61746',
  [Icons.IcLoader]: '61747',
  [Icons.IcSearch]: '61748',
  [Icons.IcTarget]: '61749',
  [Icons.Info]: '61750',
  [Icons.Information]: '61751',
  [Icons.Items]: '61752',
  [Icons.Logout]: '61753',
  [Icons.ManagementCar]: '61754',
  [Icons.MapLocation]: '61755',
  [Icons.Map]: '61756',
  [Icons.Megafon]: '61757',
  [Icons.MenuGroups]: '61758',
  [Icons.Menu_1]: '61759',
  [Icons.MenuDots]: '61760',
  [Icons.Menu]: '61761',
  [Icons.Minus]: '61762',
  [Icons.Modifiers]: '61763',
  [Icons.NoResults]: '61764',
  [Icons.Ok]: '61765',
  [Icons.Pencil]: '61766',
  [Icons.PinFilled]: '61767',
  [Icons.Pin]: '61768',
  [Icons.Plus]: '61769',
  [Icons.Points]: '61770',
  [Icons.Products]: '61771',
  [Icons.Question]: '61772',
  [Icons.Reports]: '61773',
  [Icons.Reset]: '61774',
  [Icons.ReverseArrows]: '61775',
  [Icons.Search]: '61776',
  [Icons.SelectedMapLocation]: '61777',
  [Icons.SelectedPin]: '61778',
  [Icons.ServingDish]: '61779',
  [Icons.Settings]: '61780',
  [Icons.ShoppingBag]: '61781',
  [Icons.ShoppingCart]: '61782',
  [Icons.SliderLeft]: '61783',
  [Icons.SliderRight]: '61784',
  [Icons.Smile]: '61785',
  [Icons.Spinner]: '61786',
  [Icons.Star]: '61787',
  [Icons.Swap]: '61788',
  [Icons.Terminal]: '61789',
  [Icons.Text]: '61790',
  [Icons.Trash]: '61791',
  [Icons.Wallet_1]: '61792',
  [Icons.Wallet]: '61793',
  [Icons.Warning]: '61794',
};
